import comp from "./ServiceType";
export default comp;
